import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { WorkoutsOverviewData } from 'services/workout-loader.service';
import { hasClientSmallScreen } from 'environments/environment-helpers';

import { LL } from 'i18n/i18n.service';
@Component({
  selector: 'cs-workout-overview',
  templateUrl: 'cs-workout-overview.html',
  host: { 'class': 'workout-overview' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsWorkoutOverviewComponent {
  protected LL = LL;
  hasClientSmallScreen = hasClientSmallScreen;
  @Input() workouts: WorkoutsOverviewData;
  @Input() selectedWorkout: string = '';
  @Output() selectedWorkoutChange = new EventEmitter<string>();

  onTabChange(value: string) {
    this.selectedWorkout = value;
    this.selectedWorkoutChange.emit(value);
  }

  handleSwipeForward() {
    const i = this.workouts.list.findIndex(w => w.letter === this.selectedWorkout);
    if (i >= 0 && i < this.workouts.list.length - 1) {
      this.onTabChange(this.workouts.list[i + 1].letter);
    }
  }

  handleSwipeBack() {
    const i = this.workouts.list.findIndex(w => w.letter === this.selectedWorkout);
    if (i > 0) {
      this.onTabChange(this.workouts.list[i - 1].letter);
    }
  }
}
